import Drag from '../../drag'

export default class ImgDrag extends Drag {
  useType = 'make';
  rightKeyMenu = null;
  blockInfo = {
    uuid: '',
    x: 80,
    y: 80,
    width: 80,
    height: 80,
    leftBottomCoordinate: {
      x: 160,
      y: 160
    },
    image: '',
    opaqueBottom: true, // 不透明底： true， 透明底： false
    mislead: true, // 误导标记 false: 误导， true: 正确答案
  };

  /**
   * 
   *   @param {String} plate: 区域类名(.question-design) || body
   *   @param {String} useType: 使用类型。 value: ['make', 'view']. 默认 ‘make’
   *   @param {Object} blockStyle 
   *    style: 方块样式,
   *    selectStyle: 方块选中样式
   *   @param {number | string} maxNum: 允许最多方块 默认10
   */
  constructor(obj) {
    super(obj)

    this.useType = obj.useType || this.useType
    
    this.init()
  }

  init() {
    this.customRightKeyMenu()
    
    // 只有make 才能调用
    this.useType == 'make' && this.findscroller()
  }

  // 调用基类 创建方块
  handleCreateBlock() {
    this.createBlock(node => {
      node.addEventListener('contextmenu', ev => {
        ev.preventDefault()

        let { rightKeyMenu, curBlock } = this
        rightKeyMenu.style.display = 'block'
        rightKeyMenu.style.left = `${ev.pageX}px`
        rightKeyMenu.style.top = `${ev.pageY}px`
        rightKeyMenu.focus()
        
        for(let i = 0; i < rightKeyMenu.childNodes.length; i++) {
          let item = rightKeyMenu.childNodes[i]

          if([...item.classList].indexOf('mislead-choice') > -1) {
            item.innerText = curBlock.mislead ? '取消误导选项' : '设为误导选项'
          }
          if([...item.classList].indexOf('opaque-bottom') > -1) {
            item.innerText = curBlock.opaqueBottom ? '设置为透明底层' : '设置为不透明底层' 
            break ;
          }
        }
      })
    })
  }

  /**
   * 右键自定义菜单
   */
  customRightKeyMenu() {
    let menu = document.createElement('div')
    menu.setAttribute('class', 'right-key-menu')
    menu.setAttribute('tabindex', '0')
    let singleMenu = [
      {text: '上传图片', class: 'update-image'},
      {text: '误导选项', class: 'mislead-choice'},
      {text: '设置为透明底层', class: 'opaque-bottom'},
      {text: '删除', class: 'remove-block'}
    ]

    // 追加子节点
    while(menu.childNodes.length < singleMenu.length) {
      let child = document.createElement('div'),
      item = singleMenu[menu.childNodes.length]
      child.setAttribute('class', `menu-single ${item.class}`)
      child.innerText = item.text

      // 每个按钮增加事件
      if(menu.childNodes.length == 0) child.addEventListener('click', updateImg)
      if(menu.childNodes.length == 1) child.addEventListener('click', misleadChoice)
      if(menu.childNodes.length == 2) child.addEventListener('click', setOpaqueBottom)
      else if(menu.childNodes.length == 3) child.addEventListener('click', removeBlock)

      menu.append(child)
    }

    menu.style.display = 'none'
    document.body.append(menu)
    this.rightKeyMenu = menu

    // 添加失去焦点事件
    menu.addEventListener('blur', () => {
      menu.style.display = 'none'
    })

    //  -------- 子节点事件函数 --------
    let that = this

    // 上传图片
    function updateImg() {
      let fileDom = document.createElement('input')
      fileDom.type = 'file'
      fileDom.onchange = () => {
        let files = fileDom.files[0],
        formData = new FormData();
        formData.append('file', files);

        // 临时图片
        let node = document.querySelector(`#${that.curBlock.uuid}`)
        that.curBlock.image = URL.createObjectURL(files)
        node.style.backgroundImage = `url(${that.curBlock.image})`
        node.classList.remove('error-block-style')

        // file('https://math-concept-dev.liangzhicn.com/portal/api/v1/files', formData)
        //   .then(res => {
        //     console.log(res)
        //   })
        // 重置
        fileDom.value = ''
        that.fn(that.blockMap)
      }

      fileDom.click()
    }

    // 误导选项
    function misleadChoice () {
      let { curBlock } = that
      curBlock.mislead = !curBlock.mislead

      that.rightKeyMenu.blur()
      that.fn(that.blockMap)
    }

    // 切换透明底层
    function setOpaqueBottom() {
      // 设置为透明底层
      let { curBlock: { uuid }, curBlock } = that,
      node = document.querySelector(`#${uuid}`),
      bgcolor = 'rgba(0, 0, 0, 0)'

      // 处理数据
      curBlock.opaqueBottom = !curBlock.opaqueBottom
      if(curBlock.opaqueBottom) bgcolor = '#ccc'

      // 样式修改
      node.style.backgroundColor = bgcolor
      that.rightKeyMenu.blur()

      that.fn(that.blockMap)
    }

    // 移除方块
    function removeBlock() {
      let { uuid } = that.curBlock,
      { plate } = that,
      removeNode = document.querySelector(`#${uuid}`)

      plate.removeChild(removeNode)
      that.blockMap.delete(uuid)
      that.curBlock = {}
      that.rightKeyMenu.blur()

      that.fn(that.blockMap)
    }
  }

  /**
   * 回显视图
   * @param {Array} map 
   */
  echoBlock(map, vue) {
    let { plate } = this, i = 0,
    status = ['success', 'error'], k
    , bl = 500 / 300

    // 追加
    for(;i < map.length; i++) {
      let {image, width, height, x, y, uuid, mislead, opaqueBottom, other: {id}} = map[i],
      block = document.createElement('div')
      
      // 误导方块 直接跳过 执行下一轮循环
      if(!mislead) continue;

      block.setAttribute('class', 'block-style block-style-success')
      block.setAttribute('id', uuid)
      // 还原答案
      block.style = `
        width: ${width * bl}px;
        height: ${height * bl}px;
        top: ${y * bl}px;
        left: ${x * bl}px;
        background-image: url(${image})
      `
      block.style.backgroundColor = opaqueBottom ? '#ccc' : 'rgba(0, 0, 0, 0)'
      block.dataset.subscript = i
      block.dataset.mark = -1
      block.dataset.id = id
     
      // 追加状态节点
      k = 0
      while(k < status.length) {
        let statusNode = document.createElement('div')
        statusNode.setAttribute('class', status[k])

        block.append(statusNode)
        k ++;
      }

      plate.append(block)

      // 添加拖动事件
      this.insertEvent(block, map, vue)
    }
  }

  /**
   * 回显方块 添加事件
   * @param {node} node 
   */
  insertEvent(node, map, vue) {
    let { existImage, emptyBlock } = vue
    node.ondragover = ev => {
      ev.stopPropagation()
      ev.preventDefault()
    }

    node.ondrop = ev => {
      let mark = ev.dataTransfer.getData('info')

      // 当前 block 是否存在mark标记
      if(node.dataset.mark != -1) {
        // 消除标记
        existImage.splice(existImage.indexOf(node.dataset.mark), 1)
      }

      // 标记
      node.dataset.mark = mark
      existImage.push(Number(mark))

      // 更新视图
      node.style.backgroundImage = `url(${map[mark].image})`
      // map.length
      if(existImage.length > 0) {
        vue.$emit('permissions', true)
        let blocks = this.plate.querySelectorAll('.block-style')
        vue.recordQuestion = {}
        vue.answer_results.student_choices = []
        for(let i = 0; i < blocks.length; i++) {
          // console.log(blocks, i)
          let block = blocks[i],
          bgimg = '',
          resImg = '',
          uuid = block.id,
          choice_id = Number(block.dataset.id),
          blockObject = {}
          if(block.style.backgroundImage) {
            bgimg = block.style.backgroundImage.match(/"(.+?)"/g)[0]
            resImg = bgimg.substring(1, bgimg.length - 1)
          }
          map.map(its => {
            if(its.uuid == uuid) {
              blockObject = {
                type: 'image',
                x: its.x,
                y: its.y,
                width: its.width,
                height: its.height,
                value: bgimg ? resImg : ''
              }
            }
          })
          vue.answer_results.student_choices.push({
            choice_id, value: JSON.stringify([blockObject])
          })
          vue.recordQuestion[choice_id] = resImg
        }

        // 没有上传图片的区域
        for(let i = 0; i < emptyBlock.length; i++) {
          let its = emptyBlock[i]
          let blockObject = {
            type: 'image',
            x: its.x,
            y: its.y,
            width: its.width,
            height: its.height,
            value: ''
          }
          vue.answer_results.student_choices.push({
            choice_id: its.other.id, value: JSON.stringify(!its.mislead ? [] : [blockObject])
          })
          vue.recordQuestion[its.other.id] = ''
          // console.log(vue.answer_results.student_choices)
          // console.log(vue.recordQuestion)
        }
      }
      else vue.$emit('permissions', false)
    }

    // 移除已有的图片
    node.onclick = () => {
      let mark = Number(node.dataset.mark)
      
      if(mark != -1) {
        // 更新视图
        node.querySelector('.success').style.display = 'none'
        node.querySelector('.error').style.display = 'none'

        node.style.backgroundImage = `url()`
        node.dataset.mark = -1

        existImage.splice(existImage.indexOf(mark), 1)
      }
      vue.$emit('permissions', false)
    }
  }
}